import { FormGroup, TextInput, Modal, RadioButtonGroup, RadioButton } from "carbon-components-react"; // prettier-ignore
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PinnacleFoundationLogo } from "./";
import { sendPinnacleMessage } from "../actions/email";
import { closePinnacleMessageModal } from "../actions/pinnacleMessage";
import { getPinnacleMessageOpenStatus } from "../selectors";

const defaultState = {
  organization_name: "",
  five_zero_one_c_three_status: "yes",
  event_month: "",
  event_year: "",
  event_location: "",
  first_name: "",
  last_name: "",
  phone_number: "",
  role: "",
};

const PinnacleMessage = () => {
  const dispatch = useDispatch();
  const modalOpen = useSelector(getPinnacleMessageOpenStatus);

  const [form, setForm] = useState(defaultState);
  const formComplete = Object.values(form).every((field) => Boolean(field));

  const handleFormSubmit = () => {
    dispatch(sendPinnacleMessage(form));
    dispatch(closePinnacleMessageModal());
    return true;
  };

  return (
    <Modal
      size="sm"
      className="pinnacle-message"
      open={modalOpen}
      primaryButtonDisabled={!formComplete}
      onRequestSubmit={handleFormSubmit}
      preventCloseOnClickOutside={true}
      primaryButtonText="Submit"
      secondaryButtonText="Close"
      onRequestClose={() => dispatch(closePinnacleMessageModal())}
    >
      <div style={{ textAlign: "left" }}>
        <p>
          The Pinnacle Foundation has developed this Leaderboard application to
          allow charitable organizations of all kinds to raise money through the
          power of their human networks.
        </p>
        <br />
        <p>
          Should your organization have interest in using our Leaderboard
          application to raise funds for your not for profit event, please send
          us the following and will respond to you soon.
        </p>
        <br />
        <FormGroup
          invalid={false}
          legendText=""
          message={false}
          style={{ textAlign: "left" }}
        >
          <TextInput
            id="pinnaclemessage-organization-name"
            invalid={false}
            invalidText="A valid value is required"
            labelText="Name of Organization"
            light={false}
            type="text"
            value={form.organization_name}
            onChange={(e) =>
              setForm({ ...form, organization_name: e.target.value })
            }
          />
          <RadioButtonGroup
            legendText="501(c)3?"
            name="pinnaclemessage-501c3"
            defaultSelected="yes"
            onChange={(e) =>
              setForm({ ...form, five_zero_one_c_three_status: e })
            }
          >
            <RadioButton labelText="Yes" value="yes" id="radio-1" />
            <RadioButton labelText="No" value="no" id="radio-2" />
            <RadioButton labelText="Unknown" value="unknown" id="radio-3" />
          </RadioButtonGroup>
          <TextInput
            id="pinnaclemessage-event-month"
            invalid={false}
            invalidText="A valid value is required"
            labelText="Month of Event"
            light={false}
            type="text"
            value={form.event_month}
            onChange={(e) => setForm({ ...form, event_month: e.target.value })}
          />
          <TextInput
            id="pinnaclemessage-event-year"
            invalid={false}
            invalidText="A valid value is required"
            labelText="Year of Event"
            light={false}
            type="text"
            value={form.event_year}
            onChange={(e) => setForm({ ...form, event_year: e.target.value })}
          />
          <TextInput
            id="pinnaclemessage-event-location"
            invalid={false}
            invalidText="A valid value is required"
            labelText="Location of Event"
            light={false}
            type="text"
            value={form.event_location}
            onChange={(e) =>
              setForm({ ...form, event_location: e.target.value })
            }
          />
          <TextInput
            id="pinnaclemessage-first-name"
            invalid={false}
            invalidText="A valid value is required"
            labelText="First Name"
            light={false}
            type="text"
            value={form.first_name}
            onChange={(e) => setForm({ ...form, first_name: e.target.value })}
          />
          <TextInput
            id="pinnaclemessage-last-name"
            invalid={false}
            invalidText="A valid value is required"
            labelText="Last Name"
            light={false}
            type="text"
            value={form.last_name}
            onChange={(e) => setForm({ ...form, last_name: e.target.value })}
          />
          <TextInput
            id="pinnaclemessage-phone-number"
            invalid={false}
            invalidText="A valid value is required"
            labelText="Cell Phone"
            light={false}
            type="text"
            value={form.phone_number}
            onChange={(e) => setForm({ ...form, phone_number: e.target.value })}
          />
          <TextInput
            id="pinnaclemessage-role"
            invalid={false}
            invalidText="A valid value is required"
            labelText="Role With Organization"
            light={false}
            type="text"
            value={form.role}
            onChange={(e) => setForm({ ...form, role: e.target.value })}
          />
          <p>
            Leaderboard Software Copyright 2022 by Pinnacle Foundation NFP, who
            reserves all rights to its ownership and usage.
          </p>
        </FormGroup>
        <PinnacleFoundationLogo />
      </div>
    </Modal>
  );
};

export default PinnacleMessage;
